import { Spin } from 'antd'
import { SmartMap, SmartMarker } from '@shared/innmaxMap/map/SmartMap'
import { googleMapOptions } from '@services/constants/map'
import { useAllSessions } from '@services/session'

type Props = {
  item?: any
  isEdit: boolean
}

export default function RepairMapContent({ item, isEdit, ...props }: Props) {
  const { byId } = useAllSessions()

  return (
    <div className="relative">
      <SmartMap
        {...byId[item?.sessionId]}
        zoom={8}
        googleMapOptions={{
          ...googleMapOptions,
          backRectangleSelectControl: true,
          backRectangleSelectControlOptions: {
            enableRectangleSelect: false,
            styles: {
              margin: '24px 40px 24px 0'
            }
          }
        }}
        center={
          item?.lat &&
          item?.lon && {
            lat: item.lat,
            lng: item.lon,
          }
        }
        mapContainerStyle={{
          height: 'calc(100vh / 2 + 40px + 56px)',
        }}>
        {item ? (
          <SmartMarker mapType={byId[item?.sessionId]?.type} item={item} />
        ) : (
          <Spin spinning={true} />
        )}
      </SmartMap>
    </div>
  )
}
